import flickity from "flickity";
import "flickity-imagesloaded";

class Slider {
  constructor(element) {
    this.element = element;
    this.init();
  }

  getElement() {
    return this.element;
  }

  getSlider(){
    let element = this.getElement();
    return element.querySelector('.js-sliderContainer');
  }

  getAlign() {
    return this.element.dataset.align;
  }

  getWrapAround() {
    return this.element.dataset.wrap;
  }

  getGroup() {
    return this.element.dataset.group;
  }

  getNext() {
    let element = this.getElement();
    return element.querySelector('.js-next');
  }

  getPrev() {
    let element = this.getElement();
    return element.querySelector('.js-prev');
  }

  setSlider() {
    let sliderEl = this.getSlider();
    let nextEl = this.getNext();
    let prevEl = this.getPrev();
    let align = this.getAlign();
    let wrap = this.getWrapAround();
    let group = this.getGroup();

    group === undefined || group === 'false' ? group = false : group = this.getGroup();

    wrap === undefined || wrap === 'false' ? wrap = false : wrap = true;

    let flkty = new flickity(sliderEl, {
      cellAlign: align,
      prevNextButtons: false,
      adaptiveHeight: true,
      groupCells: group,
      imagesLoaded: true,
      contain: true,
      lazyLoad: 4,
      wrapAround: wrap,
      pageDots: false,
    });

    try{
      nextEl.addEventListener('click', () => {
        flkty.next();
      })
    }catch{}

    try{
      prevEl.addEventListener('click', () => {
        flkty.previous();
      })
    }catch{}
  }

  setEventHandlers() {
    this.setSlider();
  }

  init() {
    this.setEventHandlers();
  }
}


const SliderInit = {
  init() {
    const $el = document.querySelectorAll(".js-slider");
    if ($el) {
      for(let el of $el) {
        new Slider(el);
      }
    }
  },
};


export default SliderInit;